import React from "react";

const DomainVerification = (props) => {
  const { toggleModel,message, isModalOpen, item } = props;
  let content = "";
  let dnsSubdomain = "";
  if (item.id !== undefined) {
    content = "_" + item.id.toUpperCase();
    let subdomainList = item.domain_name.split(".");
    let subdomain = "";
    if (subdomainList.length > 2) {
      for (var i = 0; i < subdomainList.length - 2; i++) {
        if (subdomain !== "") {
          subdomain = subdomain + ".";
        }
        subdomain = subdomain + subdomainList[i];
      }
    } else {
      subdomain = "shipcrm";
    }
    dnsSubdomain = "_" + item.id.toUpperCase().substring(0, 5) + subdomain;
  }
  console.log("subdomain");
  return (
    <>
      <div className={isModalOpen ? "quick_sidebar_open" : ""}>
        <div className=" quick-sidebar p-0">
          <a
            href="#"
            onClick={toggleModel}
            className="close-quick-sidebar"
            style={{ top: 0, right: "10px", zIndex: 1 }}
          >
            <i className="fas fa-times fa-lg" />
          </a>
          <div className="view">
            <div className="table_Box dataTables_wrapper">
              <div className="modal-header">
                <h4 className="mb-0"> Domain Verification </h4>
              </div>
              <div className="table_Body">
                <h6> Adding TXT record to your DNS </h6>
                <ul className="text-black-50 pl-2">
                  <li> Copy the unique text from below </li>
                  <li>
                    {" "}
                    name :{" "}
                    <span className="text-bold text-info">
                      {" "}
                      {dnsSubdomain}{" "}
                      <span  onClick={()=>{navigator.clipboard.writeText(dnsSubdomain)}}>

                      <i  className="fa fa-copy fa-lg text-info pr-2"></i>

                      </span>
                    
                      </span>{" "}
                  </li>
                  <li>
                    {" "}
                    Content :{" "}
                    <span className="text-bold text-info"> {" "}{content}{" "}
                    <span  onClick={()=>{navigator.clipboard.writeText(content)}}>
                    <i className="fa fa-copy fa-lg text-info pr-2"></i>
                    </span>
                   </span>
                  </li>
                  <li>
                    {" "}
                    Type : <span className="text-bold text-info"> TEXT</span>
                  </li>
                  <li>
                    {" "}
                    Login to the domain provider's account (For example,
                    GoDaddy, namecheap, among others) where your domain's name
                    server is pointed.{" "}
                  </li>
                  <li>
                    {" "}
                    Access your domain and navigate to it's DNS page (DNS
                    Manager or DNS Control Panel or Advanced DNS editor).{" "}
                  </li>
                  <li> Paste the Unique code and Save it.</li>
                  <li>
                    {" "}
                    Once Saved the TXT unique code in domain provider's account,
                    Comeback here and Click below the Verify button to confirm
                    the Domain Verification{" "}
                  </li>
                </ul>
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label className="w-100 text-truncate">
                          {" "}
                          Domain Name{" "}
                        </label>
                        {message.succMessage !== undefined &&
                          message.succMessage !== "" ? (
                          <>
                            <span className="text-success">
                              <i className="fas fa-check-circle mr-2"></i>
                              {message.succMessage}
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                        {message.failMessage !== undefined &&
                          message.failMessage !== "" ? (
                          <>
                            <span className="text-danger">
                              <i className="fas fa-check-circle mr-2"></i>
                              {message.failMessage}
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                        <div className="input-group">
                          <input
                            placeholder={item.domain_name}
                            className="form-control"
                            maxLength={255}
                            decimal={0}
                            disabled
                          />
                          <div className="input-group-append ">
                            <a
                              className="btn btn-success d-flex align-items-center"
                              onClick={props.VerifyHandler}
                            >
                              {" "}
                              Verify{" "}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(isModalOpen)?<div className="quick-sidebar-overlay"></div>:""}
    </>
  );
};
export default DomainVerification;
